"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLitigationLog = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const litigationLogFlowConfig = new FlowConfig_1.default({
    list: [
        '0',
        '10',
        '20',
        '30',
        '40',
        '50',
        '60',
        '70',
        '80',
        '90',
        '100'
    ]
});
const toLitigationLog = function (litigationLogId, flowKey, overdueRecordId, replace) {
    if (flowKey === 'start') {
        flowKey = litigationLogFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = litigationLogFlowConfig.getEnd();
    }
    router_1.default[replace ? 'replace' : 'push'](`/litigation/log/info/${litigationLogId}/${(0, utils_1.simpleEncrypt)(flowKey)}/${overdueRecordId || 'auto'}`);
};
exports.toLitigationLog = toLitigationLog;
exports.default = litigationLogFlowConfig;
